module.exports = __webpack_public_path__ + "img/128.d3c9dc2f.jpg";